import React from 'react';
import { useTranslation } from 'react-i18next';
import { Farecard } from '../../services/types/apitypes';
import { currencyFormat } from '../../utils/currency';
import './CardCurrentValue.css';

type CardCurrentValueProps = {
  card: Farecard;
};

export default function CardCurrentValue({ card }: CardCurrentValueProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <div className="ion-text-center cardvalue-current">
        <div className="label">{t('cardvalue.currentvalue')}</div>
        <div className="value">{currencyFormat(card.balance || 0)}</div>
      </div>
    </>
  );
}
